export type AccountsTableColumnFilter = { id: string; value: unknown };

const columnFiltersByKey = new Map<string, AccountsTableColumnFilter[]>();
const globalFilterByKey = new Map<string, string>();

const memoryKey = (uid: string, tableName: string): string =>
  `${uid}.${tableName}`;

export const getAccountsTableColumnFilters = (
  uid: string,
  tableName: string
): AccountsTableColumnFilter[] => {
  if (!uid || !tableName) {
    return [];
  }
  return columnFiltersByKey.get(memoryKey(uid, tableName)) ?? [];
};

export const setAccountsTableColumnFilters = (
  uid: string,
  tableName: string,
  filters: AccountsTableColumnFilter[]
): void => {
  if (!uid || !tableName) {
    return;
  }
  columnFiltersByKey.set(memoryKey(uid, tableName), [...filters]);
};

export const getAccountsTableGlobalFilter = (
  uid: string,
  tableName: string
): string => {
  if (!uid || !tableName) {
    return '';
  }
  return globalFilterByKey.get(memoryKey(uid, tableName)) ?? '';
};

export const setAccountsTableGlobalFilter = (
  uid: string,
  tableName: string,
  globalFilter: string
): void => {
  if (!uid || !tableName) {
    return;
  }
  globalFilterByKey.set(memoryKey(uid, tableName), globalFilter);
};

export const clearAccountsTableFilterSession = (uid?: string): void => {
  if (!uid) {
    columnFiltersByKey.clear();
    globalFilterByKey.clear();
    return;
  }
  const prefix = `${uid}.`;
  Array.from(columnFiltersByKey.keys()).forEach((key) => {
    if (key.startsWith(prefix)) {
      columnFiltersByKey.delete(key);
    }
  });
  Array.from(globalFilterByKey.keys()).forEach((key) => {
    if (key.startsWith(prefix)) {
      globalFilterByKey.delete(key);
    }
  });
};
